import feathers from 'feathers/client'
import rest from 'feathers-rest/client'
import hooks from 'feathers-hooks'
import superagent from 'superagent'

const gitBranch = process.env.GIT_BRANCH.split('/')
const envIndex = gitBranch && gitBranch[0] === 'release' ? 1 : 0
const isStaging = gitBranch[envIndex] === 'staging'

let host, hostAuth, hostBackoffice, hostRMT, hostPayProxy, hostGeo

const parentQuery = !!window.location.port && window.parent.location.search.substr(1)
const parentQueryParams = {}

if (parentQuery) {
  parentQuery.split('&').forEach(param => {
    param = param.split('=')

    parentQueryParams[param[0]] = param[1]
  })
}

if (!window.location.port && !isStaging) {
  host = 'https://api.regily.com'
  hostAuth = 'https://auth.regily.com'
  hostBackoffice = 'https://backoffice.regily.com'
  hostRMT = 'https://metadata.regily.com'
  hostGeo = 'https://geo.regily.com'
} else if (!window.location.port && isStaging) {
  host = 'https://staging-api.regily.com'
  hostAuth = 'https://staging-auth.regily.com'
  hostBackoffice = 'https://staging-backoffice.regily.com'
  hostRMT = 'https://staging-metadata.regily.com'
  hostGeo = 'https://staging-geo.regily.com'
} else {
  host = `http://${window.location.host}/api`
  hostAuth = `http://${window.location.host}/auth`
  hostBackoffice = `http://${window.location.host}/backoffice`
  hostRMT = `http://${window.location.host}/metadata`
  hostGeo = `https://staging-geo.regily.com`
}

const connectToLocalPayproxy = parentQueryParams.payproxy === 'local'
if (window.location.hostname && window.location.hostname.indexOf('test-') !== -1 && !isStaging) {
  hostPayProxy = 'https://staging-payproxy.regily.com'
} else if (window.location.hostname && window.location.hostname.indexOf('prod-') !== -1 && isStaging) {
  hostPayProxy = 'https://payproxy.regily.com'
} else if (!window.location.port && !isStaging) {
  hostPayProxy = 'https://payproxy.regily.com'
} else if (!connectToLocalPayproxy) {
  hostPayProxy = 'https://staging-payproxy.regily.com'
} else {
  hostPayProxy = `http://${window.location.host}/payproxy` // Due to port conflicts, in order to connect to local copy of payproxy it needs to run on port 3031.
}

const jwt = 'eyJhbGciOiJFUzUxMiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoiaXpldHRsZSIsImlzcyI6InJlZ2lseSJ9.AHIaZjZB5re8EBrqILouwjndQP4ikJww-rqrAA14ra05P7_iNQVhcfe4SoKOs9lODY89ohk9zitBxx-NIqN8N9DQAVdE5RwZCDpvT8J-mmVq7scd-VsuVTXjGAk4CGKGnE0hFobjoIY6w-Y8FpjfM1LCepyqh0_jrHkIuN_PYcnfJVX4'
let userId

const backend = feathers()
  .configure(hooks())
  .configure(rest(host).superagent(superagent))

const geo = feathers()
  .configure(hooks())
  .configure(rest(hostGeo).superagent(superagent))

backend.hooks({
  before (hook) {
    hook.params.headers = {
      Authorization: `Bearer ${jwt}`,
      'X-Session-Identifier': userId
    }
  }
})

const backendRMT = feathers()
  .configure(hooks())
  .configure(rest(hostRMT).superagent(superagent))

const backendAuth = feathers()
  .configure(hooks())
  .configure(rest(hostAuth).superagent(superagent))

const backendBackoffice = feathers()
  .configure(hooks())
  .configure(rest(hostBackoffice).superagent(superagent))

const backendPayProxy = feathers()
  .configure(hooks())
  .configure(rest(hostPayProxy).superagent(superagent))

export default {
  emailService: backend.service('emails'),
  addressService: backend.service('addresses'),
  genderService: backend.service('genders'),
  usernameService: backend.service('usernames'),
  companiesService: backend.service('companies'),
  personsService: backend.service('persons'),
  phonesService: backendAuth.service('otpsms'),
  paymentiqService: backendPayProxy.service('paymentiq'),
  metadataLogService: backendRMT.service('track'),
  metadataAnalyzeService: backendRMT.service('analyze'),
  metadataIdExchange: backendRMT.service('id-exchange'),
  iovationService: backendAuth.service('iovation'),
  releasesService: backendBackoffice.service('releases'),
  entercashService: backendPayProxy.service('entercash'),
  sanctionsService: backend.service('sanctions'),
  iplookupService: geo.service('iplookup'),

  install (Vue) {
    Vue.prototype.$emailService = this.emailService
    Vue.prototype.$addressService = this.addressService
    Vue.prototype.$genderService = this.genderService
    Vue.prototype.$usernameService = this.usernameService
    Vue.prototype.$companiesService = this.companiesService
    Vue.prototype.$personsService = this.personsService
    Vue.prototype.$phonesService = this.phonesService
    Vue.prototype.$entercashService = this.entercashService
    Vue.prototype.$paymentiqService = this.paymentiqService
    Vue.prototype.$sanctionsService = this.sanctionsService
    Vue.prototype.$iplookupService = this.iplookupService

    userId = Vue.prototype.$userId
  }
}



// WEBPACK FOOTER //
// ./src/api.js